// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderAddFilledSvg from "@ant-design/icons-svg/es/asn/FolderAddFilled";
import AntdIcon from '../components/AntdIcon';

var FolderAddFilled = function FolderAddFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddFilledSvg
  }));
};

FolderAddFilled.displayName = 'FolderAddFilled';
export default React.forwardRef(FolderAddFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FolderAddFilled.js
// module id = 1187
// module chunks = 0